export default {
  name: 'Event Title',
  edit: {
    form: 'name-input',
    label: 'Change the title',
    handler: value => value,
  },
};
